import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24df1884"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "flight-overlay-container" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "flex-out" };
const _hoisted_4 = _createTextVNode();
const _hoisted_5 = _withScopeId(() => _createElementVNode("br", null, null, -1));
const _hoisted_6 = { class: "text-align-right" };
const _hoisted_7 = _createTextVNode();
const _hoisted_8 = _withScopeId(() => _createElementVNode("br", null, null, -1));
const _hoisted_9 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_10 = { class: "flex-between" };
const _hoisted_11 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_12 = { class: "flex-out" };
const _hoisted_13 = { class: "font-small" };
const _hoisted_14 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_15 = { class: "grid-c3 gap-small" };
const _hoisted_16 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_17 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_18 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_19 = { class: "flex-between" };
const _hoisted_20 = { class: "grid-center margin-top-1 text-align-center" };
const _hoisted_21 = _withScopeId(() => _createElementVNode("br", null, null, -1));
const _hoisted_22 = _createTextVNode(" (Auto Refresh) ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tuple = _resolveComponent("Tuple");
    const _component_FlightProgress = _resolveComponent("FlightProgress");
    const _component_StdLineChart = _resolveComponent("StdLineChart");
    const _component_StateSvg = _resolveComponent("StateSvg");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
            class: "full-width",
            src: _ctx.imageSrc,
            alt: "aircraft image",
            onerror: "if(this.src != 'img/404.webp') this.src='img/404.webp'"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.aircraftName), 1),
                _hoisted_4,
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.liveryName), 1)
            ]),
            _createElementVNode("p", _hoisted_6, [
                _createElementVNode("b", null, _toDisplayString(_ctx.username), 1),
                _hoisted_7,
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.userTitle) + " | Grade " + _toDisplayString(_ctx.grade), 1)
            ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Tuple, {
                title: "Speed",
                value: _ctx.speed,
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                title: "Altitude",
                value: _ctx.altitude,
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                title: "Track",
                value: _ctx.track,
                class: "grid-center"
            }, null, 8, ["value"])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Tuple, {
                title: _ctx.departureTime,
                value: _ctx.icaoDeparture
            }, null, 8, ["title", "value"]),
            _createVNode(_component_FlightProgress, {
                class: "margin-inline-1",
                progress: _ctx.flightProgress
            }, null, 8, ["progress"]),
            _createVNode(_component_Tuple, {
                title: _ctx.arrivalTime,
                value: _ctx.icaoDestination,
                class: "text-align-right"
            }, null, 8, ["title", "value"])
        ]),
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.fpl), 1),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Tuple, {
                value: _ctx.xp,
                title: "XP",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.virtualGroup,
                title: "Virtual Group",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.flightTime,
                title: "Flight Time",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.atcOps,
                title: "ATC Ops",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.violationTotal,
                title: "Σ Violations",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.landings,
                title: "Landings",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.violation1,
                title: "Violations 1",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.violation2,
                title: "Violations 2",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.violation3,
                title: "Violations 3",
                class: "grid-center"
            }, null, 8, ["value"])
        ]),
        _hoisted_16,
        _createVNode(_component_StdLineChart, {
            class: "flight-overlay-chart",
            title: "Altitude",
            data: _ctx.altitudes
        }, null, 8, ["data"]),
        _hoisted_17,
        _createVNode(_component_StdLineChart, {
            class: "flight-overlay-chart",
            title: "Speed",
            data: _ctx.speeds
        }, null, 8, ["data"]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_StateSvg, {
                src: "svg/target_on.svg",
                class: "flight-overlay-action",
                onClick: _ctx.onClickTarget
            }, null, 8, ["onClick"]),
            _createVNode(_component_StateSvg, {
                src: "svg/share.svg",
                class: "flight-overlay-action",
                onClick: _ctx.onClickShare
            }, null, 8, ["onClick"]),
            _createVNode(_component_StateSvg, {
                src: "svg/download.svg",
                class: "flight-overlay-action",
                onClick: _ctx.onClickDownload
            }, null, 8, ["onClick"])
        ]),
        _createElementVNode("p", _hoisted_20, [
            _createTextVNode(" Time Report : " + _toDisplayString(_ctx.lastUpdated) + " ", 1),
            _hoisted_21,
            _hoisted_22
        ])
    ]));
}
